import { TextFieldProps } from '@material-ui/core'
import { TextInput as CustomTextInput } from './styles'

export const TextInput = ({ ...props }: TextFieldProps) => (
  <CustomTextInput {...props} />
)
